// src/context/StyleContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const StyleContext = createContext();

export const useStyle = () => useContext(StyleContext);

export const StyleProvider = ({ children }) => {
  const [styles, setStyles] = useState({
    textColor: "#DFDDC7",
    fontFamily: "Orbitron",
    backgroundColor: "#211717",
    restaurantName: "Hop",
    restaurantLogo: "/booths/memories/logo.png",
    loadingAnimation: "/booths/memories/home.webm",
    printingAnimation: "/booths/memories/print.webm",
    particlesColor: "#c8a189",
    buttonColor: "#c8a189",
    borderColor: "#eab676",
    lineColor: "#eab676",
    printLogo_White: "/booths/memories/printLogo_White.png",
    printLogo_Black: "/booths/memories/printLogo_Black.png",
    isPaymentOn: false,

    blackStripButtonName: "Black",
    blackStripBackgroundColor: "black",
    whiteButtonName: "White",
    whiteStripBackgroundColor: "white",
    imageScale: "1.5",
  });
  const [boothName, setBoothName] = useState("");

  useEffect(() => {
    const fetchStyles = async () => {
      const name = localStorage.getItem("photobooth_boothName");
      console.log("Booth Name from localStorage:", name); // Debugging log

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/restaurants`
        );
        console.log("API Response:", response.data); // Debugging log

        const settings = response.data.find(
          (item) => item.restaurantName === name
        );
        console.log("Settings found:", settings); // Debugging log

        if (settings) {
          setStyles((prev) => ({
            ...prev,
            ...settings,
          }));
          console.log("Updated Styles:", settings); // Debugging log
        }
      } catch (error) {
        console.error("Failed to fetch styles:", error);
      }
    };

    fetchStyles();
  }, []); // Only run once on mount

  useEffect(() => {
    console.log("Styles updated:", styles); // Debugging log
  }, [styles]); // Log styles whenever it updates

  return (
    <StyleContext.Provider value={styles}>{children}</StyleContext.Provider>
  );
};
